<template>
  <div class="goods-tabs">
    <nav>
      <a
        @click="activeName = 'GoodsDetial'"
        :class="{ active: activeName === 'GoodsDetial' }"
        href="javascript:;"
      >
        <span>{{ $t('product.productDetail') }}</span></a
      >
      <a
        @click="activeName = 'GoodsParams'"
        :class="{ active: activeName === 'GoodsParams' }"
        href="javascript:;"
      >
        <span>{{ $t('product.sizeParams') }}</span></a
      >
      <a
        @click="activeName = 'agentNotes'"
        :class="{ active: activeName === 'agentNotes' }"
        href="javascript:;"
        ><span>{{ $t('product.shopNotes') }}</span></a
      >
      <a
        @click="activeName = 'afterSaleService'"
        :class="{ active: activeName === 'afterSaleService' }"
        href="javascript:;"
        ><span>{{ $t('product.saleService') }}</span></a
      >
    </nav>
    <!-- 切换内容的地方 其实两个组件-->
    <!-- 在vue中动态的去切换组件其实可以使用动态组件component组件 -->
    <!-- is属性用来决定component动态组件渲染为那个组件，组件的名称 -->
    <!-- <GoodsDetial v-if="activeName === 'GoodsDetial'" />
    <GoodsComment v-if="activeName === 'GoodsComment'" /> -->
    <component :is="activeName"></component>
  </div>
</template>
<script>
import { inject, ref } from 'vue'
import afterSaleService from './after-sale-service'
import agentNotes from './agent-notes'
import GoodsDetial from './goods-detial'
import GoodsParams from './GoodsParams'
export default {
  name: 'GoodsTabs',
  components: { GoodsDetial, GoodsParams, agentNotes, afterSaleService },
  setup() {
    // activeName的值：GoodsDetial  GoodsComment
    const activeName = ref('GoodsDetial')
    // goods详情数据
    const goods = inject('goods')
    return { activeName, goods }
  },
}
</script>
<style scoped lang="scss">
.goods-tabs {
  min-height: 600px;
  background: var(--white-color-1);
  // position: relative;
  width: 660px;

  nav {
    height: 66px;
    display: flex;
    justify-content: flex-start;
    border-bottom: 1px solid #f5f5f5;
    position: sticky;
    top: 80px;
    background-color: var(--white-color-1);
    z-index: 1;

    a {
      display: flex;
      align-items: center;
      padding-right: 12px;
      width: 175px;
      font-size: 18px;
      line-height: 20px;
      position: relative;
      font-family: Montserrat;
      text-transform: capitalize;
      color: $gray-color;
      font-weight: bold;
      word-break: break-word;

      &.active {
        color: var(--primary-color);

        &::before {
          content: '';
          position: absolute;
          bottom: -1px;
          width: 130px;
          height: 3px;
          background: $xtxColor;
        }
      }
    }
  }
}
</style>
